import React from 'react';
import PropTypes from 'prop-types';

// Wistia and Vimeo serve a poster frame from their metadata API, but a video
// given as a direct file url has no such service. Pointing a muted video element
// just past the start makes it paint its own first frame into the tile instead
// (CON-8753).
const PDPVideoPosterFrame = ({ className, src }) =>
  !!src && (
    <video
      className={className}
      src={`${src}#t=0.1`}
      muted
      playsInline
      preload="metadata"
      tabIndex={-1}
      aria-hidden="true"
    />
  );

PDPVideoPosterFrame.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
};

export default PDPVideoPosterFrame;
